import React from 'react'
import Button from './Button'

const SQLayout = ({potential, setStep}) => {

  return <div className='sSlide'>
      <div className='compCard sLay'>
        <strong>MSR Introduction</strong>
        <span>AV Provider</span>
        <span>Fast Quotes</span>
        <span>Top Rated</span>
        <span>Partner Portal</span>
        <strong>Meeting Agenda</strong>
        <span>Get to know a little better your business</span>
        <span>Explain our different models</span>
        <span>Platform Demo</span>
        <span>Partnership Projections</span>
      </div>
      <div className="buttons">
        <Button className='btn-4 highLight ' onClick={() => setStep(1)} >Continue</Button>
      </div>
  </div>
}

export default SQLayout